import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorCoachesConsultantsPage() {
  return <SectorPageTemplate sectorName="Coaches & Consultants" sectorSlug="coaches-consultants" heroTitle="Webdesign voor coaches en consultants" heroDescription="Professionele websites voor coaches, consultants, personal trainers en sportscholen. Wij bouwen websites die expertise uitstralen en leads genereren." whyTitle="Waarom een goede website essentieel is voor coaches" whyDescription="Jij bent je merk. Een sterke online aanwezigheid bouwt autoriteit op en trekt de juiste cliënten aan." whyItems={[{
    icon: 'StarIcon',
    title: 'Expertise tonen',
    description: "Deel je kennis via blogs, cases en video's om jezelf als autoriteit in jouw vakgebied te positioneren."
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Afspraken plannen',
    description: 'Laat potentiële cliënten direct een kennismakingsgesprek of intake inplannen via je website.'
  }, {
    icon: 'TrendingUpIcon',
    title: 'Leadgeneratie',
    description: 'Verzamel e-mailadressen met e-books of checklists om je mailinglijst op te bouwen.'
  }, {
    icon: 'UsersIcon',
    title: 'Personal branding',
    description: 'Jouw persoonlijkheid staat centraal. We bouwen een design dat perfect past bij jouw identiteit.'
  }]} features={[{
    icon: 'CalendarCheckIcon',
    title: 'Afspraakplanner',
    description: 'Koppeling met Calendly of een eigen systeem voor het direct inplannen van sessies.'
  }, {
    icon: 'FileTextIcon',
    title: 'Intake formulier',
    description: 'Uitgebreide formulieren om vooraf al de juiste informatie van je cliënten te verzamelen.'
  }, {
    icon: 'BookOpenIcon',
    title: 'Blog & Kennisbank',
    description: "Een overzichtelijk platform om je artikelen, podcasts of video's te delen met je doelgroep."
  }]} clusters={[{
    name: 'Coaching',
    slug: 'coaching',
    label: 'Coach',
    description: 'Websites voor life coaches, business coaches en loopbaancoaches.'
  }, {
    name: 'Consultant',
    slug: 'consultant',
    label: 'B2B',
    description: 'Zakelijke websites voor consultants en interim professionals.'
  }, {
    name: 'Sportschool',
    slug: 'sportschool',
    label: 'Fitness',
    description: "Websites voor sportscholen, yogastudio's en crossfit boxen."
  }, {
    name: 'Personal Trainer',
    slug: 'personal-trainer',
    label: 'PT',
    description: 'Websites voor personal trainers met focus op transformaties en intakes.'
  }]} faqs={[{
    q: 'Kan ik een online cursus verkopen via mijn website?',
    a: 'Ja, we kunnen je website uitbreiden met een e-learning module (zoals LearnDash) of koppelen aan externe platforms zoals Huddle of Plug&Pay.'
  }, {
    q: 'Hoe kom ik aan meer aanmeldingen voor kennismakingsgesprekken?',
    a: 'We optimaliseren de website voor conversie met duidelijke call-to-actions, social proof (reviews) en een laagdrempelige afspraakmodule.'
  }, {
    q: 'Wat kost een website voor een coach?',
    a: 'Een professionele coach-website start vanaf €1.500. Wil je ook online cursussen verkopen of een uitgebreide ledensite, dan maken we een offerte op maat.'
  }, {
    q: 'Kan ik zelf makkelijk blogs toevoegen?',
    a: 'Absoluut. WordPress is van origine een blogsysteem en is perfect geschikt voor het regelmatig publiceren van nieuwe artikelen en content.'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1880" />;
}